import { useState } from 'react';
import { SubmissionError } from 'redux-form';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { LangSelector, ThemeChanger, UiVersionSwitch } from 'libs/ui';
import { LoginFormV2 } from './form.v2';
import { Screen, Card, Left, LoginLogo, GateWrap, Right, RightTitle, Footer, FooterTools } from './auth.v2.styled';

// CleverParking redesign of the login screen (v2): split card with a pure-CSS
// entry gate on the left and the login form on the right. On successful login
// the barrier raises before navigating in.
export const AuthV2 = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const referrer = location.state?.referrer;
  const [opened, setOpened] = useState(false);

  const submit = (values) => {
    // Open the barrier only once auth succeeds, hold it up long enough to see,
    // then let `login` redirect (delay must exceed the arm-raise transition).
    return user
      .login(values, referrer ?? '/', { onSuccess: () => setOpened(true), delay: 1800 })
      .catch((error) => {
        setOpened(false);
        throw new SubmissionError({ _error: error });
      });
  };

  return (
    <Screen>
      <Card className={opened ? 'cp-gate-open' : undefined}>
        <Left className="cp-login-left">
          <LoginLogo src="/images/cleverpark.svg" alt="CLEVER PARK" />

          <GateWrap>
            <div className="cp-gate" aria-hidden>
              <div className="cp-gate-rack">
                <span className="cp-gate-eye" />
              </div>
              <div className="cp-gate-arm" />
              <div className="cp-gate-post" />
              <div className="cp-gate-ground" />
            </div>
          </GateWrap>
        </Left>

        <Right>
          <RightTitle>{t('form.loginTitle')}</RightTitle>
          <LoginFormV2 onSubmit={submit} opened={opened} />
          <Footer>
            <UiVersionSwitch />
            <FooterTools>
              <ThemeChanger withBg />
              <LangSelector dropUp />
            </FooterTools>
          </Footer>
        </Right>
      </Card>
    </Screen>
  );
};
